import React, {Component} from 'react';
import {
    Button,
    Form,
    Container,
    Header, Grid
} from 'semantic-ui-react';
import update from 'react-addons-update';

import StoreProfileData from "../../data/StoreProfileData";
import {showToast} from "../../actions/ToastAction";
import {connect} from "react-redux";
import Loading from "../extras/Loading";

class SocialForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                facebook: '',
                twitter: '',
                instagram: ''
            },
            sending: false,
            loading: true
        };

        this.handleFacebookChange = this.handleFacebookChange.bind(this);
        this.handleTwitterChange = this.handleTwitterChange.bind(this);
        this.handleInstagramChange = this.handleInstagramChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    async handleSubmit(event) {
        event.preventDefault();
        this.setState({sending:true});
        StoreProfileData.updateSocialNetworks(this.state.data, (res) => {
            if (res.update) {
                this.props.showToast({message:'Información Actualizada!', type:'success'});
            } else {
                this.props.showToast({message:'El formato de los enlaces no es correcto!', type:'error'});
            }
            this.setState({sending:false});
        });
    }

    handleFacebookChange(event) {
        let data = update(this.state, {
            data: {
                facebook: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
    };

    handleTwitterChange(event) {
        let data = update(this.state, {
            data: {
                twitter: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
    };

    handleInstagramChange(event) {
        let data = update(this.state, {
            data: {
                instagram: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
    };

    async initialFetch() {
        const data = await StoreProfileData.getSocialNetworks();
        this.setState({data, loading:false});
    }

    render() {
        return (
            <Container>
                <Header as='h2'>
                    <Header.Content>
                        Redes Sociales
                    </Header.Content>
                </Header>
                {this.state.loading ? <Loading/>:
                <Grid>
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Input label='Facebook' placeholder='https://facebook.com/bisttros' value={this.state.data.facebook}
                                            onChange={this.handleFacebookChange}/>
                                <Form.Input label='Instagram' placeholder='http://instagram.com/bisttros' value={this.state.data.instagram}
                                            onChange={this.handleInstagramChange}/>
                                <Form.Input label='Twitter' placeholder='http://twitter.com/bisttros' value={this.state.data.twitter}
                                            onChange={this.handleTwitterChange}/>
                                <Button primary fluid type="submit" content="Actualizar Información" disabled={this.state.sending}
                                        loading={this.state.sending}/>
                            </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>}
            </Container>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        showToast(toast){
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(SocialForm)


// WEBPACK FOOTER //
// ./src/components/settings/SocialForm.js